import React from 'react';
import NamespaceFormatsProvider from './NamespaceFormatsProvider';
import namespaceFormats from './namespaceFormats';

type DefaultNamespaceFormatsProviderProps = {
  children: React.ReactNode;
};

const DefaultNamespaceFormatsProvider = ({
  children,
}: DefaultNamespaceFormatsProviderProps) => {
  return (
    <NamespaceFormatsProvider namespaceFormats={namespaceFormats}>
      {children}
    </NamespaceFormatsProvider>
  );
};

export default DefaultNamespaceFormatsProvider;
